// components/DirectionsSection.jsx
import SectionReveal from './SectionReveal';

export default function DirectionsSection({ t }) {
  const directions = Array.isArray(t?.directions) ? t.directions : [];

  return (
    <SectionReveal animation="fade-up" delay={600}>
      <div className="pt-8">
        <h3 className="text-md font-bold uppercase tracking-[0.3em] text-[#0FA4E8] mb-6">
          {t?.directionsTitle || 'Մեր հիմնական ուղղությունները'}
        </h3>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {directions.map((direction, idx) => {
            const label = typeof direction === 'string' ? direction : direction?.title || '';

            return (
              <div
                key={idx}
                className="group flex md:justify-between items-center gap-6 backdrop-blur-lg relative p-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#0FA4E8]/30 transition-all cursor-pointer"
              >
                <h4 className="text-sm font-bold text-white leading-tight mb-1">
                  {label}
                </h4>
              </div>
            );
          })}
        </div>
      </div>
    </SectionReveal>
  );
}